export interface IdName<T = any> {
	Id: T;
	Name: string;
}

export const EmptyIdName: IdName<number> = {
	Id: 0,
	Name: ''
};
